import { render, staticRenderFns } from "./HomeReportsTable.vue?vue&type=template&id=4998f4a9&"
import script from "./HomeReportsTable.vue?vue&type=script&lang=js&"
export * from "./HomeReportsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports